import { config } from '@/config/env';
import { ApiResponse } from '@/interfaces/api-response.interface';
import { TokenStorage } from '@shared/handle-local-storage';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

const baseUrl: string = config.API_BASE_URL

const apiClient = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
})

apiClient.interceptors.request.use(
  (config) => {
    // Aqui você pode adicionar headers de autenticação
    const token = TokenStorage.get()
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const { response } = error

    // Tratamento de erros específicos
    if (response?.status === 401) {
      // Remove token if exists
      TokenStorage.remove();

      // Only redirect if not already on login page
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }

    return Promise.reject(error.response)
  }
)

export const api = {
  get: async <T>(url: string, config?: AxiosRequestConfig) => {
    const response = await apiClient.get<T>(url, config)
    return response.data
  },

  post: async <T>(url: string, data?: any, config?: AxiosRequestConfig) => {
    const response = await apiClient.post<T>(url, data, config)
    return response.data
  },

  put: async <T>(url: string, data?: any, config?: AxiosRequestConfig) => {
    const response = await apiClient.put<T>(url, data, config)
    return response.data
  },

  patch: async <T>(url: string, data?: any, config?: AxiosRequestConfig) => {
    const response = await apiClient.patch<T>(url, data, config)
    return response.data
  },

  delete: async <T>(url: string, config?: AxiosRequestConfig) => {
    const response = await apiClient.delete<T>(url, config)
    return response.data
  }
}

export default apiClient
